import React from 'react';
import { motion } from 'framer-motion';
import { Utensils, Baby, Sparkles } from 'lucide-react';
export function ImportantThings() {
  return <section className="py-24 bg-cream border-y border-sand" data-id="element-288">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-289">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-290">
          <motion.h2 className="text-4xl font-serif text-charcoal mb-6" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-291">
            Empezar los sólidos no debería sentirse como una batalla
          </motion.h2>
          <motion.p className="text-xl text-warmGray font-serif italic" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-292">
            Tu bebé no necesita perfección. Necesita un adulto informado,
            presente y tranquilo.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-293">
          <motion.div className="flex flex-col items-center text-center space-y-6" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-294">
            <div className="w-16 h-16 rounded-full bg-white shadow-sm flex items-center justify-center border border-sand" data-id="element-295">
              <Utensils className="w-6 h-6 text-terracotta" data-id="element-296" />
            </div>
            <div data-id="element-297">
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-298">
                La mesa es un lugar de alegría
              </h3>
              <p className="text-warmGray leading-relaxed" data-id="element-299">
                Si hay tensión, la nutrición se detiene. El vínculo importa
                tanto como el alimento.
              </p>
            </div>
          </motion.div>

          <motion.div className="flex flex-col items-center text-center space-y-6" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-300">
            <div className="w-16 h-16 rounded-full bg-white shadow-sm flex items-center justify-center border border-sand" data-id="element-301">
              <Baby className="w-6 h-6 text-sage" data-id="element-302" />
            </div>
            <div data-id="element-303">
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-304">
                Tu bebé tiene su propio ritmo
              </h3>
              <p className="text-warmGray leading-relaxed" data-id="element-305">
                Habrá días de mucha curiosidad y otros de poca ingesta. Ambos
                son parte del proceso.
              </p>
            </div>
          </motion.div>

          <motion.div className="flex flex-col items-center text-center space-y-6" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-306">
            <div className="w-16 h-16 rounded-full bg-white shadow-sm flex items-center justify-center border border-sand" data-id="element-307">
              <Sparkles className="w-6 h-6 text-mauve" data-id="element-308" />
            </div>
            <div data-id="element-309">
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-310">
                Calidad sobre cantidad
              </h3>
              <p className="text-warmGray leading-relaxed" data-id="element-311">
                Cada bocado cuenta cuando eliges alimentos reales y con
                propósito.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}